import authHeader from "../../../authentication/authservices/auth-header";
import apiClient from "../../../http-common";

export const fetchAlterDoctorDetailsByBillNo = (postObj) => {
  return apiClient.post(`administration/getChargesByBill`, postObj, {
    headers: authHeader(),
  });
};

export const saveAlterDoctorByBillNo = (postObj) => {
  return apiClient.post(`administration/updateDoctorCharges`, postObj, {
    headers: authHeader(),
  });
};
